module.exports = __webpack_public_path__ + "static/media/Elise10.35dfaecf.jpg";